import { ChangeDetectionStrategy, Component, computed, inject, input, model, output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

import { TipoImpressaoAta } from '../ata-reuniao.presenter';

import { DialogoPadraoDirective } from '@/shared/components/layout/dialogo-padrao/dialogo-padrao.directive';
/** Diálogo de pré-visualização da ata/minuta — renderiza o documento gerado num iframe `sandbox`. */
@Component({
    selector: 'app-ata-preview',
    standalone: true,
    imports: [DialogoPadraoDirective, ButtonModule, DialogModule],
    templateUrl: './ata-preview.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AtaPreviewComponent {
    private readonly sanitizer = inject(DomSanitizer);

    /** Visibilidade do diálogo (two-way). */
    readonly visivel = model(false);
    /** Documento HTML completo já gerado/higienizado (pelo presenter) a ser exibido. */
    readonly documentoHtml = input('');
    /** Tipo de documento em exibição (destaca o botão ativo). */
    readonly tipo = input<TipoImpressaoAta>('minuta');
    /** Solicita a troca do tipo (o pai regenera o documento). */
    readonly selecionarTipo = output<TipoImpressaoAta>();

    /**
     * HTML pronto para o `srcdoc`. Exceção justificada ao "sem bypass": o `srcdoc` exige um documento
     * HTML completo (`<html><head><style>…`) que o sanitizer do Angular removeria; o conteúdo já é
     * higienizado por `sanitizarHtmlDocumento` (presenter) e o iframe é `sandbox` (sem execução de
     * script) — dupla mitigação de XSS.
     */
    protected readonly documentoSafe = computed<SafeHtml>(() => this.sanitizer.bypassSecurityTrustHtml(this.documentoHtml()));

    protected fechar(): void {
        this.visivel.set(false);
    }
}
